import {
  Body1,
  Textarea,
  Toolbar,
  ToolbarButton,
  ToolbarDivider,
  Tooltip,
} from '@fluentui/react-components'
import { DeleteLinesRegular, TableDeleteColumnRegular } from '@fluentui/react-icons'
import 'ag-grid-community/styles/ag-theme-balham.css'
import { useTranslation } from 'react-i18next'
import { useStyles } from './TableFiltering.styles'
import { useTableEditorContext } from './useTableEditorContext'

/**
 * Renders the table filtering UI. Must be used inside a TableEditorProvider
 * (supplied by TableFilterModal), which owns all grid state via useTableEditor.
 */
const TableFiltering = () => {
  const {
    gridContainerRef,
    tableTitle,
    tableFooter,
    statusMessage,
    updateTableTitle,
    updateTableFooter,
    handleDeleteSelected,
    handleDeleteColumn,
    canDeleteRows,
    canDeleteColumn,
  } = useTableEditorContext()
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <section className={classes.modalSection}>
      <Textarea
        aria-label={t('tables.titleLabel')}
        placeholder={t('tables.titlePlaceholder')}
        value={tableTitle}
        onChange={(_e, data) => updateTableTitle(data.value)}
        resize="vertical"
        size="small"
        className={classes.titleFooterField}
      />
      <Toolbar aria-label={t('tables.toolbar')} className={classes.toolbar} size="small">
        <Tooltip content={t('tables.deleteSelected')} relationship="label">
          <ToolbarButton
            icon={<DeleteLinesRegular className={canDeleteRows ? classes.deleteIcon : undefined} />}
            onClick={handleDeleteSelected}
            aria-label={t('tables.deleteSelected')}
            disabled={!canDeleteRows}
          />
        </Tooltip>
        <Tooltip content={t('tables.deleteColumn')} relationship="label">
          <ToolbarButton
            icon={
              <TableDeleteColumnRegular
                className={canDeleteColumn ? classes.deleteIcon : undefined}
              />
            }
            onClick={handleDeleteColumn}
            aria-label={t('tables.deleteColumn')}
            disabled={!canDeleteColumn}
          />
        </Tooltip>
        <ToolbarDivider />
        <Body1 as="p" className={classes.status}>
          {statusMessage}
        </Body1>
      </Toolbar>
      <div className={classes.modalGridContainer}>
        <div ref={gridContainerRef} className={`ag-theme-balham ${classes.grid}`} />
      </div>
      <Textarea
        aria-label={t('tables.footerLabel')}
        placeholder={t('tables.footerPlaceholder')}
        value={tableFooter}
        onChange={(_e, data) => updateTableFooter(data.value)}
        resize="vertical"
        size="small"
        className={classes.titleFooterField}
      />
    </section>
  )
}

export { TableFiltering }
